<template>
  <v-card
    v-if="
      isRefundForm &&
      ($route.name == `Luo kohdistettu hyvityslasku` || $route.name == 'Luo hyvitys vakuuslaskuun')
    "
    class="mt-2"
  >
    <v-card-title>Perustiedot</v-card-title>

    <v-container>
      <v-row dense>
        <v-col>
          <div
            v-if="
              isRefundForm &&
              ($route.name == `Luo kohdistettu hyvityslasku` ||
                $route.name == 'Luo hyvitys vakuuslaskuun')
            "
          >
            <p>
              Hyvityslasku laskulle nro. <strong> {{ invoice.invoiceNumber }}</strong>
            </p>

            <p>
              Hyvitettävän laskun alkuperäiset saatavat:
              <strong>
                {{ formatCurrency(invoice.totalAmount) }}
              </strong>
            </p>
          </div>
        </v-col>
      </v-row>

      <v-row v-if="invoice.refundInvoiceIds.length > 0" dense>
        <v-col>
          <p class="mb-2 error--text">
            <strong
              >Laskulle on jo luotu {{ invoice.refundInvoiceIds.length }} hyvityslasku(a)</strong
            >
          </p>

          <div v-for="(invoice, idx) in invoice.refundInvoiceIds" :key="idx + 'a'">
            <div class="mb-2">
              <p class="mb-1">
                <strong>{{ idx + 1 }}. Hyvityslasku {{ invoice.invoiceNumber }}</strong>
              </p>
              <p>
                Laskun pvm:
                {{
                  invoice.billDate ? formatDate(invoice.billDate) : formatDate(invoice.createdAt)
                }}
              </p>
              <p>
                {{
                  invoice.sendDate ? `Lähetetty ${formatDate(invoice.sendDate)}` : "Ei lähetetty"
                }}
              </p>
              <p>
                Yhteensä:
                <strong>{{ calcRefundAmount(invoice) }}</strong>
              </p>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import mixins from "@/mixins/mixins";
import invoiceHelpers from "@/utils/invoiceHelpers";

export default {
  mixins: [mixins],

  props: ["isRefundForm", "invoice"],

  methods: {
    calcRefundAmount(invoice) {
      return this.formatCurrency(invoiceHelpers.calcProductsTotalAmount(invoice));
    },
  },
};
</script>

<style scoped>
p {
  font-size: 14px;
}
</style>
